<template>
  <!--第四步：应用企业基本信息 -->
  <div class="enterpriseInfo">
    <el-form
      ref="form"
      :model="form"
      :rules="rules"
      label-width="175px"
      class="form-wrap"
      :disabled="disabled"
    >
      <el-form-item label="应用企业名称：" prop="reportingUnit">
        <el-input v-model="form.reportingUnit" placeholder="请输入" clearable />
      </el-form-item>
      <el-form-item label="所属市、县（区）：" prop="regionValue">
        <el-cascader
          v-model="form.regionValue"
          :options="regionOptions"
          placeholder="请选择省/市/区县"
          :props="{ multiple: false }"
          clearable
          @change="changeRegion"
          style="width: 385px;"
        ></el-cascader>
      </el-form-item>
      <el-row>
        <el-col :span="12">
          <el-form-item label="成立时间：" prop="established">
            <el-date-picker
              v-model="form.established"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="请选择成立时间"
              style="width:100%"
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="所属行业：" prop="industry">
            <el-input v-model="form.industry" placeholder="请输入" clearable />
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="统一信用代码：" prop="code">
        <el-input v-model="form.code" placeholder="请输入" clearable />
      </el-form-item>
      <el-row>
        <el-col :span="12">
          <el-form-item label="企业人数：" prop="number">
            <el-input v-model="form.number" placeholder="请输入" clearable />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="参保职工人数：" prop="insuredNumber">
            <el-input v-model="form.insuredNumber" placeholder="请输入" clearable />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="上年度主营业务收入：" prop="lastRevenue">
            <el-input v-model="form.lastRevenue" placeholder="请输入" clearable class="w300" />
            <span>万元</span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="本年度主营业务收入：" prop="currentRevenue">
            <el-input v-model="form.currentRevenue" placeholder="请输入" clearable class="w300" />
            <span>万元</span>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="企业简介：" prop="content">
        <el-input
          v-model="form.content"
          type="textarea"
          :autosize="{ minRows: 4, maxRows: 6 }"
          placeholder="请输入"
          clearable
        />
      </el-form-item>
      <el-row>
        <el-col :span="12">
          <el-form-item label="联系人：" prop="contact">
            <el-input v-model="form.contact" placeholder="请输入" clearable />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="联系人电话：" prop="contactTel">
            <el-input v-model="form.contactTel" placeholder="请输入" clearable />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="联系人职务：" prop="contactJob">
            <el-input v-model="form.contactJob" placeholder="请输入" clearable />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="联系人邮箱：" prop="contactMail">
            <el-input v-model="form.contactMail" placeholder="请输入" clearable />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import {
  saveFourthInfo,
  sumbitAllInfo,
  getFourthInfo
} from "../../utils/interface";
import ningxia from "../../utils/ningxia";
import provinceData from "../../utils/provinceData";
const form = () => {
  return {
    reportingUnit: "", // 申报单位
    regionValue: "", // 省/区/县
    provice: "",
    city: "",
    area: "",
    established: "", // 成立时间
    industry: "", // 所属行业
    code: "", // 统一信用代码
    number: "", // 企业人数
    insuredNumber: "", // 参保职工人数
    lastRevenue: "", // 上年度主营业务收入
    currentRevenue: "", // 本年度主营业务收入
    content: "", // 企业简介
    contact: "", // 联系人
    contactTel: "", // 联系人电话
    contactJob: "", // 联系人职务
    contactMail: "" // 联系人邮箱
  };
};
const rules = () => {
  return {
    reportingUnit: [
      { required: true, message: "请输入申报单位", trigger: "blur" }
    ],
    regionValue: [
      { required: true, message: "请选择省/区/县", trigger: "change" }
    ],
    established: [
      { required: true, message: "请选择成立时间", trigger: "change" }
    ],
    industry: [{ required: true, message: "请输入所属行业", trigger: "blur" }],
    code: [{ required: true, message: "请输入统一信用代码", trigger: "blur" }],
    number: [{ required: true, message: "请输入企业人数", trigger: "blur" }],
    insuredNumber: [
      { required: true, message: "请输入参保职工人数", trigger: "blur" }
    ],
    lastRevenue: [
      {
        required: true,
        message: "请输入上年度主营业务收入",
        trigger: "blur"
      }
    ],
    currentRevenue: [
      {
        required: true,
        message: "请输入本年度主营业务收入",
        trigger: "blur"
      }
    ],
    content: [{ required: true, message: "请输入企业简介", trigger: "blur" }],
    contact: [{ required: true, message: "请输入联系人", trigger: "blur" }],
    contactTel: [
      { required: true, message: "请输入联系人电话", trigger: "blur" }
    ],
    contactJob: [
      { required: true, message: "请输入联系人职务", trigger: "blur" }
    ],
    contactMail: [
      { required: true, message: "请输入联系人邮箱", trigger: "blur" }
    ]
  };
};
export default {
  name: "",
  components: {},
  props: {
    projectId: String
  },
  data() {
    return {
      form: form(),
      rules: rules(),
      regionOptions: provinceData,
      disabled: false,
      uuid: ""
    };
  },
  watch: {},
  computed: {},
  created() {},
  mounted() {
    if (this.$route.query.projectId) {
      // console.log('第四步')
      this.getFourthInfo(this.$route.query.projectId);
    }
  },
  methods: {
    /* 获取第四步详情 */
    getFourthInfo(projectId) {
      getFourthInfo(projectId).then(res => {
        if (res.success && Object.keys(res.data).length > 0) {
          this.form = res.data;
          this.getRegion();
          this.disabled =
            this.$route.query.status == "INIT" ||
            this.$route.query.status == "REJECT"
              ? false
              : true;
          this.uuid = res.data.uuid;
        } else {
          this.form = form();
        }
      });
    },
    /* 第四步保存 */
    async save(type) {
      // console.log('第四步保存')
      await this.saveFourthInfo();
      await this.sumbitAllInfo(type);
      this.$router.push("/projectApply");
    },
    /* 服务商应用保存 */
    saveFourthInfo() {
      return new Promise((resolve, reject) => {
        this.$refs.form.validate(valid => {
          if (valid) {
            saveFourthInfo({
              policyUuid: this.$route.query.policyUuid,
              userUuid: this.$store.state.isUsermessage.uuid,
              projectId: this.projectId,
              ...this.form,
              uuid: this.uuid
            }).then(res => {
              if (res.success) {
                this.uuid = res.data.uuid;
                resolve();
              } else {
                reject();
              }
            });
          }
        });
      });
    },
    /* 申报提交、保存 */
    sumbitAllInfo(type) {
      return new Promise((resolve, reject) => {
        sumbitAllInfo(this.projectId, type).then(res => {
          if (res.success) {
            this.$message({
              message: res.message,
              type: "success"
            });
            // this.$parent.activeStep++
            resolve();
          } else {
            this.$message({
              message: res.message,
              type: "error"
            });
            reject();
          }
        });
      });
    },
    /* 改变区市 */
    changeRegion(val) {
      // console.log(val)
      if (val) {
        this.form.provice = val[0];
        this.form.city = val[1];
        this.form.area = val[2];
      } else {
        this.form.provice = "";
        this.form.city = "";
        this.form.area = "";
      }
    },
    /* 回显省/区/市 */
    getRegion() {
      this.form.regionValue = [
        this.form.provice,
        this.form.city,
        this.form.area
      ];
    }
  }
};
</script>
<style lang="less" scoped>
@import "../../assets/css/common.less";

.enterpriseInfo {
  min-height: 300px;
  margin-bottom: 35px;
  border-radius: 12px;

  .form-wrap {
    padding: 10px 20px;
    .bs();

    p {
      font-size: 14px;
      color: #888888;
      line-height: 1.7;
      margin-bottom: 40px;
    }
    .w300 {
      width: 300px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/projectApply/enterpriseInfo.vue